module.exports = __webpack_public_path__ + "static/media/PopUp_Informativo.28e3de47.png";